var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bar"},[_c('div',{staticClass:"bar-item tooltip",style:(_vm.style),attrs:{"data-tooltip":_vm.formattedPercent}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.percent)+"%")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }